import initialState from './initialState';
import { reducer as loginReducer } from './login';
import { reducer as fetchStatisticsReducer } from './fetchStatistics';
import { reducer as fetchLoginStatisticsReducer } from './fetchLoginStatistics';
import { reducer as fetchLicensesReducer } from './fetchLicenses';
import { reducer as getProductsReducer } from './getProducts';
import { reducer as getCustomersReducer } from './getCustomers';
import { reducer as getLoginTimesReducer } from './getLoginTimes';
import { reducer as getExerciseStatisticsReducer } from './getExerciseStatistics';
import { reducer as doBootstrapingReducer } from './doBootstraping';
const reducers = [
  loginReducer,
  fetchStatisticsReducer,
  fetchLoginStatisticsReducer,
  fetchLicensesReducer,
  getProductsReducer,
  getCustomersReducer,
  getLoginTimesReducer,
  getExerciseStatisticsReducer,
  doBootstrapingReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/home/redux/reducer.js